import {useContext} from 'react';
import {storeContext} from '../storage';

export const useStorageUserListContext = () => useContext(storeContext);
